import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../services/interceptor";
import { fetchCalendarData, fetchDemandesRendezvous, fetchRendezvousByStatus, fetchRendezvousExceptEnAttente } from "./rendezVousPrestaSlice";

// Action pour récupérer tous les rendez-vous (déjà existante)
export const fetchRendezvous = createAsyncThunk(
  "appointments/fetchAll", // Mise à jour du nom pour plus de clarté
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}appointments?per_page=50`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// Nouvelle action pour récupérer un rendez-vous spécifique par ID
export const fetchRendezvousById = createAsyncThunk(
  "appointments/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}appointments/${id}`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      // console.error("API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// Nouvelle action pour récupérer un reservation spécifique par ID
export const fetchReservationById = createAsyncThunk(
  "reservations/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}reservations/${id}`;
      const response = await axios.get(apiUrl, {
        // Added await here
        headers: { Authorization: `Bearer ${token}` },
      });
     // console.log("API Response:", response.data); // Now this will log actual data
      return response.data;
    } catch (error) {
      // console.error("API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// get prestations pour la page de conirmation creation rdv
// Nouvelle action pour récupérer un rendez-vous spécifique par ID
export const fetchPrestationsByReservationId = createAsyncThunk(
  "reservations/fetchPrestationsByReservationId",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}reservations/${id}/other-prestations`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      //console.log(response?.data);
      return response.data;
    } catch (error) {
      // console.error("API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// get available slots
export const getAvailableSlots = createAsyncThunk(
  "appointments/getAvailableSlots",
  async (endpoint, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}etablissements/${endpoint}`;
      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      // console.error("API Error:", error);
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
//Update Rendez-vous
export const updateRendezVous = createAsyncThunk(
  "appointments/update",
  async (appointment, { rejectWithValue, dispatch}) => {
     // console.log("here:")
    try {
      const token = localStorage.getItem("token");
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const role = storedUser?.role;
      const { id, ...payload } = appointment;
      const apiUrl = `${process.env.REACT_APP_API_URL}appointments/${id}`;
      const response = await axios.put(apiUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }); 
    //  dispatch(fetchRendezvous()); 
      // dispatch(fetchCalendarData()); 
      if(role == "prestataire")   {
        // console.log("access here")
       dispatch(fetchDemandesRendezvous());     
      dispatch(fetchRendezvousByStatus());  
     dispatch(fetchRendezvousExceptEnAttente()); 
      }
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
); // Action to create a new appointment
export const createRendezvous = createAsyncThunk(
  "appointments/create",
  async (appointmentData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}reservations`,
        appointmentData,
        { headers }
      );
      setCreatedRdv(response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// create adresse de facturation reservations/add-adresse
export const createAdrFacturation = createAsyncThunk(
  "adresseFacturation/create",
  async (appointmentData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}reservations/add-adresse`,
        appointmentData,
        { headers }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// demande de remboursement
export const demandeRemboursement = createAsyncThunk(
  "appointments/Refund",
  async (remboursement, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const { id, ...payload } = remboursement;
      const apiUrl = `${process.env.REACT_APP_API_URL}demande-remboursements`;
      const response = await axios.post(apiUrl, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    //  console.log("response.data:", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

//Action pour recupérer une facture d'un rendez-vous
export const fetchInvoiceByRdvId = createAsyncThunk(
  "rdv/fetchInvoiceByRdvId",
  async (rdvId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}invoices/${rdvId}`;
      const response = await axios.get(apiUrl,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      //console.log("fetchInvoiceByRdvId",response?.data?.invoice_url)
      return response?.data?.invoice_url;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const rendezVousSlice = createSlice({
  name: "rendezvous",
  initialState: {
    rendezvous: [], // Liste des rendez-vous
    currentRdv: null, // Rendez-vous spécifique
    status: "idle", // Statut général (pour fetchRendezvous)
    currentRdvStatus: "idle", // Statut spécifique pour fetchRendezvousById
    currentReservation: null,
    currentReservationError: null,
    currentReservationStatus: null,
    error: null,
    currentRdvError: null, // Erreur spécifique pour fetchRendezvousById
    selectedPrestations: [],
    facturation: { adr: null, status: null },
    otherPrestas: { prestations: null, status: null },
    detailsRDV: {
      type: null,
      rue: null,
      ville: null,
      contact: null,
      valueContact: null,
    },
    employe: { checked: false, selectedEmploye: null, isEditing: true },
    selectedSlotRdv: { slot: null, isEditing: true },
    isEditing: true,
    availableSlots: null, // etablissement slice
    demandeRemboursementStatus: "idle", //demande de remboursement
    demandeRemboursementError: null,
    invoice: null,
  },
  reducers: {
    setIsEditing(state, action) {
      state.isEditing = action.payload;
    },
    setSelectedEmploye(state, action) {
      state.employe.selectedEmploye = action.payload;
      state.employe.checked = true;
    },
    setCheckedEmploye(state, action) {
      state.employe.checked = action.payload;
    },
    setEditingEmploye(state, action) {
      state.employe.isEditing = action.payload;
    },
    clearRendezvous: (state) => {
      state.rendezvous = [];
      state.status = "idle";
      state.error = null;
    },
    clearCurrentRdv: (state) => {
      state.currentRdv = null;
      state.currentRdvStatus = "idle";
      state.currentRdvError = null;
    },
    addSelectedPrestation: (state, action) => {
      const exists = state.selectedPrestations.some(
        (presta) => presta.id === action.payload.id
      );
      if (!exists) {
        state.selectedPrestations.push(action.payload);
      }
    },
    removeSelectedPrestation: (state, action) => {
      state.selectedPrestations = state.selectedPrestations.filter(
        (p) => p.id !== action.payload.id
      );
    },
    clearSelectedPrestations: (state) => {
      // Vide le tableau si nécessaire
      state.selectedPrestations = [];
    },
    // Set all details at once
    setDetailsRDV: (state, action) => {
      state.detailsRDV = {
        ...state.detailsRDV,
        ...action.payload,
      };
    },

    // Update specific fields
    updateDetailsRDV: (state, action) => {
      const { field, value } = action.payload;
      state.detailsRDV[field] = value;
    },

    // Reset to initial state
    resetDetailsRDV: (state) => {
      state.detailsRDV = {
        type: null,
        rue: null,
        ville: null,
        contact: null,
        valueContact: null,
      };
      state.selectedSlotRdv= { slot: null, isEditing: true };
      state.employe= { checked: false, selectedEmploye: null, isEditing: true };
    },

    // Individual field setters
    setRDVType: (state, action) => {
      state.detailsRDV.type = action.payload;
    },

    setRDVAddress: (state, action) => {
      state.detailsRDV.rue = action.payload.rue;
      state.detailsRDV.ville = action.payload.ville;
    },

    setRDVContact: (state, action) => {
      state.detailsRDV.contact = action.payload.contact;
      state.detailsRDV.valueContact = action.payload.value;
    },
    setSelectedSlotR: (state, action) => {
      state.selectedSlotRdv.slot = action.payload;
      state.selectedSlotRdv.isEditing = true;
    },
    setEditingSlotR: (state, action) => {
      state.selectedSlotRdv.isEditing = action.payload;
    },
    setCreatedRdv: (state, action) => {
      state.currentRdv = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Pour fetchRendezvous (liste des rendez-vous)
    builder
      .addCase(fetchRendezvous.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRendezvous.fulfilled, (state, action) => {
        //console.log("refraiche list")
        state.status = "succeeded";
        state.rendezvous = action.payload;
      })
      .addCase(fetchRendezvous.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Erreur inconnue";
      })
      // Pour fetchRendezvousById (rendez-vous spécifique)
      .addCase(fetchRendezvousById.pending, (state) => {
        state.currentRdvStatus = "loading";
        state.currentRdvError = null;
      })
      .addCase(fetchRendezvousById.fulfilled, (state, action) => {
        state.currentRdvStatus = "succeeded";
        state.currentRdv = action.payload;
      })
      .addCase(fetchRendezvousById.rejected, (state, action) => {
        state.currentRdvStatus = "failed";
        state.currentRdvError = action.payload || "Erreur inconnue";
      })
      // Pour reservation
      .addCase(fetchReservationById.pending, (state) => {
        state.currentReservationStatus = "loading";
        state.currentReservation = null;
      })
      .addCase(fetchReservationById.fulfilled, (state, action) => {
        state.currentReservationStatus = "succeeded";
        //console.log("action.payload", action.payload);
        state.currentReservation = action.payload;
      })
      .addCase(fetchReservationById.rejected, (state, action) => {
        state.currentReservationStatus = "failed";
        state.currentReservationError = action.payload || "Erreur inconnue";
      })
      .addCase(getAvailableSlots.pending, (state, action) => {
        state.slotsStatus = "loading";
        state.error = null;
      })
      .addCase(getAvailableSlots.fulfilled, (state, action) => {
        state.slotsStatus = "succeeded";
        state.availableSlots = action.payload;
      })
      .addCase(updateRendezVous.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateRendezVous.fulfilled, (state, action) => {       
        // fetchCalendarData();
        state.status = "succeeded";
        // Mise à jour le rendez-vous courant
        state.currentRdv = action.payload;
      })
      .addCase(updateRendezVous.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Erreur inconnue";
      })
      // Create appointment reducers
      .addCase(createRendezvous.pending, (state) => {
        state.creationStatus = "loading";
        state.error = null;
      })
      .addCase(createRendezvous.fulfilled, (state, action) => {
        state.creationStatus = "succeeded";
        state.currentAppointment = action.payload;
      })
      .addCase(createRendezvous.rejected, (state, action) => {
        state.creationStatus = "failed";
        state.error = action.payload;
      })
      //create adresse de facturation createAdrFacturation
      .addCase(createAdrFacturation.fulfilled, (state, action) => {
        state.facturation.status = "succeeded";
        state.facturation.adr = action.payload;
      })
      .addCase(fetchPrestationsByReservationId.fulfilled, (state, action) => {
        state.otherPrestas.status = "succeeded";
        state.otherPrestas.prestations = action.payload;
      })
      //demande de remboursement
      .addCase(demandeRemboursement.pending, (state) => {
        state.demandeRemboursementStatus = "loading";
        state.demandeRemboursementError = null;
      })
      .addCase(demandeRemboursement.fulfilled, (state, action) => {
        state.demandeRemboursementStatus = "succeeded";
        state.demandeRemboursementError = null;
      })
      .addCase(demandeRemboursement.rejected, (state, action) => {
        state.demandeRemboursementStatus = "failed";
        state.demandeRemboursementError = action.payload || "Erreur inconnue";
      })

      .addCase(fetchInvoiceByRdvId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoiceByRdvId.fulfilled, (state, action) => {
        state.loading = false;
        state.invoice = action.payload;
      })
      .addCase(fetchInvoiceByRdvId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Sélecteurs
export const selectRendezVous = (state) => state.rendezvous.rendezvous; // Liste des rendez-vous
export const selectCurrentRdv = (state) => state.rendezvous.currentRdv; // Rendez-vous spécifique
export const selectDetailsRDV = (state) => state.rendezvous.detailsRDV;
// Export des actions et du reducer
export const {
  clearRendezvous,
  setDetailsRDV,
  updateDetailsRDV,
  resetDetailsRDV,
  setRDVType,
  setCreatedRdv,
  setRDVAddress,
  setIsEditing,
  setSelectedEmploye,
  setSelectedSlotR,
  setEditingSlotR,
  setCheckedEmploye,
  setEditingEmploye,
  setRDVContact,
  clearCurrentRdv,
  addSelectedPrestation,
  clearSelectedPrestations,
  removeSelectedPrestation,
} = rendezVousSlice.actions;
export default rendezVousSlice.reducer;
